var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.showLogin)?_c(_setup.AppLogin,{on:{"loggedIn":_vm.loggedIn}}):_c('div',{attrs:{"id":"app"}},[_c(_setup.MenuHeader,{on:{"logout":_vm.logout}}),_c('div',{staticClass:"container"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }